import request from './request'
import * as http from '@/libs/http'

/**
 * API 接続トークンを取得する
 *
 * @returns {Response} レスポンスデータ
 */
export function newToken () {
  return request.get('/auth/token', {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
